import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {BillingFrequencyTypeService} from 'app/blocks/service/api/billing-frequency-type.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IBillingFrequencyType} from 'app/blocks/model/billing-frequency-type.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {BillingFrequencyType} from 'app/blocks/model/billing-frequency-type.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class BillingFrequencyTypeResource extends AbstractEntityResource<IBillingFrequencyType> {
    constructor(billingFrequencyTypeService: BillingFrequencyTypeService, router: Router) {
        super(
            Resource.BILLING_FREQUENCY_TYPES,
            billingFrequencyTypeService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.BILLING_FREQUENCY_TYPES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.BILLING_FREQUENCY_TYPES),
            (entity?) => new BillingFrequencyType(entity),
            (entity) => entity.code
        );
    }
}
